import * as React from 'react';
import { Redirect } from 'react-router-dom';

import withServices from '../../../../HOCs/withServices';
import NavBar from '../../../../components/CustomNav/CustomNav.Component';
import { StyledRow, IconWrapper, ContentWrapper } from '../UserEngagement.styles';
import { Container } from '../../Common/Common.styles';

// temp icons, maybe :-)
import energy from '../../../../assets/images/onboard/energy-icon.svg'
import feelgood from '../../../../assets/images/onboard/feelgood-icon.svg'
import memory from '../../../../assets/images/onboard/memory-icon.svg'


const icons = {
    "energy": energy,
    "feelgood":feelgood,
    "memory":memory,
}

interface IProps {
    services?: any;
    history?: any;
}

interface IState {
    navigate: boolean;
    destination: string;
    userType: string;
}

class SelectOnboardingUser extends React.Component <IProps, IState> {
    private ls = window.localStorage;
    constructor(props) {
        super(props);
        this.state = {
            destination: '',
            navigate: false,
            userType: ''
        }

        this.onLogout = this.onLogout.bind(this);
        this.selectUser = this.selectUser.bind(this);
    }

    public async componentDidMount() {
        // the usual
        // this.ls.clear();
        const userType = this.ls.getItem('usertype');
        if(userType !== null) {
            const destination = `/onboarding/${userType}`  ;
            const navigate = true;
            this.setState({navigate, destination});       
        }
    }
    public onLogout() {
        this.setState({navigate: true, destination: '/login'});
    }

    public selectUser(userType) {
        // add selected usertype to localStorage
        // call navigate to correct userType onboarding
        this.ls.setItem('usertype', userType);
        this.navigate(this.ls.getItem('usertype')); // safer to pass what is in the localStorage to ensure it was successfully set        
    }

    public navigate(userType) {
        const { history } = this.props;
        console.log("Navigate to: " + userType);
        history.push(`/onboarding/${userType}`);
    }

    public render() {
        if(this.state.navigate) {
            return <Redirect to={this.state.destination} />
        }

        return (
          <Container>
            <NavBar logoutParent={this.onLogout} />
            <StyledRow>
              <h1 className="onboarding-greeting">
                Welcome to Performance Learning{" "}
              </h1>
              <h2 className="onboarding-user">
                First tell us who you are . . .{" "}
              </h2>
              <ContentWrapper>
                <IconWrapper onClick={this.selectUser.bind(this, "student")}>
                  <div className="icon-wrap">
                    <img src={icons.energy} alt="" />
                  </div>
                  <p className="icon-description">Learner</p>
                </IconWrapper>
                <IconWrapper onClick={this.selectUser.bind(this, "parent")}>
                  <div className="icon-wrap">
                    <img src={icons.memory} alt="" />
                  </div>
                  <p className="icon-description">Parent</p>
                </IconWrapper>
                <IconWrapper onClick={this.selectUser.bind(this, "school")}>
                  <div className="icon-wrap">
                    <img src={icons.feelgood} alt="" />
                  </div>
                  <p className="icon-description">Institution</p>
                </IconWrapper>
              </ContentWrapper>
            </StyledRow>
          </Container>
        );
    }
}

export default withServices(SelectOnboardingUser);



// WEBPACK FOOTER //
// ./src/pages/Onboard/UserEngagement/SelectOnboardingUser/SelectOnboardingUser.Component.tsx